import { render, staticRenderFns } from "./SelectDom.vue?vue&type=template&id=1a740a65&scoped=true&"
import script from "./SelectDom.vue?vue&type=script&lang=js&"
export * from "./SelectDom.vue?vue&type=script&lang=js&"
import style0 from "./SelectDom.vue?vue&type=style&index=0&id=1a740a65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a740a65",
  null
  
)

export default component.exports